import {httpService} from '@/services';
import {AxiosError, AxiosPromise, AxiosResponse} from 'axios';

type method = 'get' | 'post';

export interface options {
  method: method;
  parameters?: any;
}

export class ServiceHelper {
  public static mapToPromise = <T>(url: string, options: options = {method: 'get'}): Promise<T> =>
      new Promise<T>((resolve, reject) => {
        const get = (): AxiosPromise<T> => httpService.http.get<T>(url);
        const post = (): AxiosPromise<T> => httpService.http.post<T>(url, options.parameters);
        const dic: { type: method, action: () => AxiosPromise<T> }[] = [
          {type: 'get', action: get},
          {type: 'post', action: post}
        ];

        const {action} = dic.findOrFirst(x => x.type === options.method);

        action()
            .then(res => res.data)
            .then(x => resolve(x))
            .catch(err => {
              console.error(err);
              reject(err);
            })
      });

  public static generateFile = <T>(url: string, nameFile: string, options: options = {method: 'get'}): Promise<void> =>
      new Promise<void>((resolve, reject) => {
        const get = (): AxiosPromise<T> => httpService.httpBlob.get<T>(url);
        const post = (): AxiosPromise<T> => httpService.httpBlob.post<T>(url, options.parameters);
        const dic: { type: method, action: () => any }[] = [
          {type: 'get', action: get},
          {type: 'post', action: post}
        ];

        const {action} = dic.findOrFirst(x => x.type === options.method);

        action()
            .then((res: AxiosResponse) => {
              let contentName: string = '';
              let content = res.headers['content-disposition'];
              if (content) {
                contentName = content.split('filename=')[1];
              }

              const blob = new Blob([res.data], {
                type: 'application/xlsx'
              });
              kendo.saveAs({
                dataURI: window.URL.createObjectURL(blob),
                fileName:  nameFile ? nameFile : contentName
              });
              resolve();
            })
            .catch((err: AxiosError) => {
              console.log('Error', err);
              reject(err);
            })
      });
}
